module.exports = new __parcel__URL__("bossfight_star_dust_button.1443a4a2.png").toString();